import React, { useState, useEffect } from "react";
import {
  BaseButtons,
  DropDownWithDisplay,
  LoadingPopUp,
  TextInputField,
  TextInputFieldArea,
} from "../../../../../common-components";
import { colors } from "../../../../../../themes/Colors";
import ImageUploadAWS from "../../../../../user/components/image-upload/ImageUploadAWS";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];

const finesSelectionList = [
  "F01",
  "F02",
  "F03",
  "F04",
  "F05",
  "F06",
  "F07",
  "F08",
  "F41",
];

const AddOffensePopUp = ({
  activeView,
  setActiveView,
  SubmitHandler,
  setToastPop,
  setMessage,
  loading,
  setLoading,
  auth,
  setRefresh,
  refresh,
  setPopUpTitle,
}) => {
  const [vehicleIdentifier, setVehicleIdentifier] = useState("");
  const [offenseReference, setOffenseReference] = useState("");
  const [incidentDate, setIncidentDate] = useState(new Date());
  const [offenseDescription, setOffenseDescription] = useState("");
  const [documentUuid, setDocumentUuid] = useState("");
  const [imageData, setImageData] = useState(null);
  const [imageError, setImageError] = useState(null);
  const [file, setFile] = useState(null);
  const [opened, setOpened] = useState(null);
  const [vehicleFound, setVehicleFound] = useState(false);
  const [vehicleSearchArray, setVehicleSearchArray] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [vehicleReg, setVehicleReg] = useState(null);

  const [fineFormType, setFineFormType] = useState("Fine Form Selection");

  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setFile(file);
  };

  const populateVehicleSearchArray = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/enatis/getEnatisMasterList",
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
        }
      );

      const responseData = await response.json();
      if (responseData.enatisVehicles) {
        setLoading(false);
        setVehicleSearchArray(responseData.enatisVehicles);
        return;
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  const searchVehicleRegistration = async (value) => {
    const vehicleId = null;
    try {
      vehicleId = vehicleSearchArray.find(
        (vehicle) => vehicle.registrationNr === value
      );
      console.log("vehicle id", vehicleId);
      if (vehicleId !== null) {
        setVehicleIdentifier(vehicleId._id);
      }
    } catch (e) {
      setToastPop(true);
      setMessage("Vehicle not found");
      setPopUpTitle("NOT FOUND");
    }

    if (vehicleId !== null) {
      setVehicleFound(true);
    }
    return vehicleFound;
  };

  const addOffense = async () => {
    setLoading(true);
    if (!validFileTypes.find((type) => type === file.type)) {
      setImageError("File type must be JPG or PNG format");
      return;
    } else {
      setImageError("");
      setImageData(file);
    }
    try {
      const formData = new FormData();

      formData.append("image", file);
      formData.append("vehicleIdentifier", vehicleReg);
      formData.append("offenseReference", offenseReference);

      formData.append("incidentDate", incidentDate);
      formData.append("offenseDescription", offenseDescription);

      formData.append("loggedByUser", auth.customerUserData.userId);
      formData.append("documentType", fineFormType);

      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/offense/createOffense",
        {
          method: "POST",
          // headers: {
          //   "Content-Type": "application/json",
          //   // Authorization: `bearer ${token}`,
          // },

          body: formData,
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setToastPop(true);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setActiveView("");
        setRefresh(refresh ? false : true);
        setLoading(false);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage(respnseData.message);
        setLoading(false);
      }
    } catch (err) {
      console.log("err", err);
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage(
        "No network try again after connecting, if this persists please contact support"
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!file) {
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setPreviewUrl(fileReader.result);
    };
    fileReader.readAsDataURL(file);
  }, [file]);

  useEffect(() => {
    populateVehicleSearchArray();
  }, []);

  return (
    <div
      style={{
        height: activeView === "add" ? "100%" : 0,
        opacity: activeView === "add" ? 1 : 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        transition: "all 0.8s",
      }}
    >
      <div
        style={{
          flex: 1,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: "60%",
            height: "80%",
            position: "relative",
          }}
        >
          <div
            style={{
              flex: 0.5,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TextInputField
              mini={true}
              labelTitle={"Vehicle Registration"}
              size={300}
              value={vehicleReg}
              onChange={(e) => setVehicleReg(e.target.value)}
            />
            <TextInputField
              mini={true}
              labelTitle={"Offense Ref"}
              size={300}
              value={offenseReference}
              onChange={(e) => setOffenseReference(e.target.value)}
            />
            <TextInputField
              mini={true}
              labelTitle={"Incident Date"}
              size={300}
              value={incidentDate}
              onChange={(e) => setIncidentDate(e.target.value)}
            />
            <TextInputFieldArea
              mini={true}
              labelTitle={"Offense Description"}
              size={300}
              value={offenseDescription}
              onChange={(e) => setOffenseDescription(e.target.value)}
            />
            <ImageUploadAWS
              mini={true}
              labelTitle={"Upload Document"}
              size={300}
              onChange={(e) => handleFileChange(e)}
            />
          </div>
          <div
            style={{
              flex: 0.5,
              justifyContent: "center",
              alignItems: "center",
              // borderStyle: "solid",
              height: "100%",
              marginLeft: 20,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ width: "88%", marginBottom: 10, fontSize: 14 }}>
              Please fine form type
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >
              <BaseButtons
                label={fineFormType}
                backgroundColor={colors.greenDark}
                width={"100%"}
                onClick={() => setFineFormType("")}
              />
              {fineFormType === "" ? (
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    backgroundColor: colors.white,
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  {finesSelectionList.map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          zIndex: 10,
                        }}
                      >
                        <div style={{ minHeight: 4 }} />
                        <BaseButtons
                          label={item}
                          backgroundColor={colors.greenDark}
                          width={"100%"}
                          onClick={() => setFineFormType(item)}
                        />
                      </div>
                    );
                  })}{" "}
                </div>
              ) : null}
            </div>

            <div style={{ minHeight: 330 }} />
          </div>
        </div>
        {/* back and close buttons */}
        <div style={{ position: "absolute", top: 10, left: 10, zIndex: 301 }}>
          <BaseButtons
            label={"CLOSE"}
            width={100}
            backgroundColor={colors.secondaryOrange}
            onClick={() => {
              setActiveView("catalog");
              setVehicleSearchArray([]);
            }}
            borderRadius={10}
          />
        </div>
        <div
          style={{
            position: "absolute",
            top: 20,
            fontSize: 18,
            fontWeight: "bold",
            color: colors.secondaryDarkBlue,
            left: 140,
          }}
        >
          ADD OFFENSE
        </div>
        {/* next and complete buttons */}
        <div style={{ position: "absolute", top: 10, right: 10 }}>
          <BaseButtons
            label={"SUBMIT"}
            width={100}
            backgroundColor={colors.greenLight}
            borderRadius={10}
            onClick={() => addOffense()}
          />
        </div>
      </div>
    </div>
  );
};

export default AddOffensePopUp;
